import _ from "lodash"
import {
	StatusLabel,
	Image
} from "~/components";
import {renderDate, arrayToMap, numberFormat} from "~/utils";
import {Pagination, Table, Tag} from "antd";
import PersonnelAction from "./PersonnelAction";
import {useCan, useDevice} from "~/hooks";
import {useContext} from "react";
import {AppContext} from "~/context/AppProvider";

function PersonnelTable({items = [], listGroup, pagination, setItemEdit, openModal, onPaginationChange, locked, unlocked}) {

	const {tableHeight} = useContext(AppContext);

	const {isMobile} = useDevice();

	const canEditPay = useCan('personnelPay');

	const canLimit = useCan('personnelListLimit');

	const canAdd = useCan('personnelAdd');

	let columns = [
		{ title: 'Họ tên', dataIndex: 'fullname', key: "fullname", width: '300px', render: (_, item) => (
			<>
				<div className="d-flex gap align-items">
					<div className="avatar"><Image src={item?.avatar} /></div>
					<div>
						<b>{item?.firstname + ' ' + item?.lastname}</b>
						<p>{item?.username} {isMobile && <StatusLabel small type={item.role.badge}>{item.role.label}</StatusLabel>}</p>
						{(isMobile && item.group?.name) && <p className="font-bold">{item.group.name}</p>}
						{isMobile && <p> {item?.phone}</p> }
						{isMobile && <p> {item?.email}</p> }
					</div>
				</div>
			</>
		)},
		{ title: 'Thông tin', dataIndex: 'contact', key: "contact", render: (_, item) => (
			<>
				<p> {item?.phone}</p>
				<p> {item?.email}</p>
				<p> {renderDate(item?.birthday)}</p>
			</>
		)},
		{ title: 'HĐ đang giữ', dataIndex: 'papers', key: "papers", width: '100px', render: (_, item) => (
			<p> {item?.papers}</p>
		)},
		{ title: 'Phép năm đã dùng', dataIndex: 'holiday', key: "holiday", width: '100px', render: (_, item) => (
			<p> {item?.holiday}</p>
		)},
		{ title: 'Chức vụ', dataIndex: 'role', key: "role", width: '200px', render: (_, item) => (<StatusLabel small type={item.role.badge}>{item.role.label}</StatusLabel>) },
		{ title: 'Nhóm', dataIndex: 'group', key: "group", width: '170px', render: (_, item) => (
			<>
				<Tag color={item?.company.badge}>{item?.company.label}</Tag>
				{(item.group?.name) && item.group?.name}
			</>
		)},
		{ title: 'Ngày nhận việc', dataIndex: 'timeStartJob', key: "timeStartJob", responsive: ['lg'], width: '140px', render: (_, item) => (renderDate(item?.timeStartJob)) },
		{ title: 'Loại', dataIndex: 'status', key: "status", responsive: ['lg'], render: (_, item) => (
			<div>
				{item.locked === 1 && <StatusLabel small type="red">Đang tạm khóa</StatusLabel>}
				{item.locked === 0 && <StatusLabel small type={item.status?.badge}>{item.status?.label}</StatusLabel>}
				{(item.status !== 'public' && item.status !== 'trash') && <p className="mt-1" style={{fontSize:'13px', color:'#999'}}>{renderDate(item?.time)}</p> }
			</div>
		)},
		{ title: 'Lương', dataIndex: 'pay', key: "pay", render: (_, item) => (
			<div>
				{(item.pay !== 0) ? <p>Cứng: <b>{numberFormat(item?.pay)}</b></p> : ''}
				{item.payType && <StatusLabel small type="green">Loại {item?.payType}</StatusLabel>}
			</div>
		)},
		{ title: '#', dataIndex: 'action', key: "action", width: '150px', render: (_, item) => (
			<PersonnelAction item={item} setItemEdit={setItemEdit} openModal={openModal} locked={locked} unlocked={unlocked}/>
		)},
	];

	if(!canEditPay) {
		_.remove(columns, (column) => {return column.key === 'pay'})
	}
	if(canLimit) {
		columns = columns.filter(function (currentValue) {
			return (currentValue.key !== 'papers'
				&& currentValue.key !== 'group'
			)
		})
	}

	if(!canAdd) {
		columns = columns.filter(function (currentValue) {
			return (currentValue.key !== 'holiday')
		})
	}

	if(isMobile) {
		columns = columns.filter(function (currentValue) {
			return (currentValue.key !== 'contact'
				&& currentValue.key !== 'role'
				&& currentValue.key !== 'group'
			)
		})
	}

	const dataSource= items.map(row => ({
		key: row.id, // I added this line
		...row
	}));

	return (
		<div className="table-wrapper">
			<div className="table-box">
				<Table
					columns={columns} dataSource={dataSource} scroll={{ y:tableHeight, x: 'max-content' }} pagination={false}
				/>
			</div>
			<Pagination current={pagination.page} defaultCurrent={1} defaultPageSize={20} pageSize={pagination.limit} total={pagination.total} onChange={onPaginationChange}  showSizeChanger={false} />
		</div>
	)
}

export default PersonnelTable;